import { render } from "./MainBannerComponent.vue?vue&type=template&id=573923ed&scoped=true"
import script from "./MainBannerComponent.vue?vue&type=script&lang=js"
export * from "./MainBannerComponent.vue?vue&type=script&lang=js"

import "./MainBannerComponent.vue?vue&type=style&index=0&id=573923ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573923ed"]])

export default __exports__